import { AxiosInstance, AxiosResponse } from 'axios';
import { TGetAdsResponse } from '../types/ads';
import { TLocaleAPI } from '../types/locale';

export type TAdEndpoints = {
    getAds: (slotList: string[]) => Promise<AxiosResponse<TGetAdsResponse>>;
};

export default (api: AxiosInstance, apiLocale: TLocaleAPI): TAdEndpoints => {
    const getAds = async (slotList: string[]): Promise<AxiosResponse<TGetAdsResponse>> =>
        api.post<TGetAdsResponse>('/_svc/ads-api/get-ads', { slotList }, { headers: { 'x-locale': apiLocale } });

    return {
        getAds,
    };
};
